import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from '@app/layout/layout.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-checkout-success',
  templateUrl: './checkout-success.component.html',
  styleUrls: ['./checkout-success.component.less'],
})
export class CheckoutSuccessComponent implements OnInit {
  DocNum: string;
  DocType: string;
  dbShoppingCartId: string;
  documentTitle: string;
  isDraft: string;
  extraMessage: string = '';

  userIdentity = g.userIdentity;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.DocNum = params.docNum;
      this.DocType = params.docType;
      this.dbShoppingCartId = params.dbShoppingCartId;
      this.isDraft = params.isDraft; //params.documentTitle;
      this.documentTitle = this.getDocumentTypeName(this.DocType); //params.documentTitle;
      //if (this.isDraft === 'true') {
      this.extraMessage = g.sc_ExtraMessageForDraft;
      //}
    });
  }

  goToShoppingCart() {
    if (this.userIdentity.Area === 1) {
      this.router.navigate(['/apps/crm/shoppingCart'], {
        queryParams: {
          dbShoppingCartId: this.dbShoppingCartId,
        },
      });
    } else {
      this.router.navigate([
        `/apps/external-portal/app-container/${g.currentAppId}/shopping/${this.dbShoppingCartId}`,
      ]);
    }
  }

  getDocumentTypeName(docType: string): string {
    let result = '';
    if (docType == '17') {
      result = this.layoutService.translate('Sales Order');
    }
    if (docType == '13') {
      result = this.layoutService.translate('Invoice');
    }
    if (docType == '23') {
      result = this.layoutService.translate('Sales Quotation');
    }

    return result;
  }
}
